import { render, staticRenderFns } from "./BxLcdjForm.vue?vue&type=template&id=452737aa&"
import script from "./BxLcdjForm.vue?vue&type=script&lang=js&"
export * from "./BxLcdjForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports